// Escuchar / Susurrar / Irrumpir llaman al softphone del supervisor, que solo existe en la pestaña /webphone.
// Si no está registrado el backend responde 409 sin originar nada: se abre el Marcador y se reintenta hasta
// que conecte. Se intenta primero sin abrir, así no se duplica el registro si el Marcador ya está abierto
// (en esta u otra pantalla) y no hay que preguntarle a nadie si lo está.
//
// post()  -> promesa de POST /monitor/spy.   openWebphone() -> window.open(...) (null si el navegador lo bloquea).
export async function spyWithWebphone(post, openWebphone, { delayMs = 1500, tries = 10 } = {}) {
  try {
    return await post();
  } catch (e) {
    if (e?.response?.status !== 409) throw e;

    if (!openWebphone()) {
      e.response.data = { ...e.response.data, error: 'El navegador bloqueó la ventana del Marcador. Permite las ventanas emergentes de este sitio o ábrelo desde el menú (Marcador).' };
      throw e;
    }

    for (let i = 0; i < tries; i++) {
      await new Promise((r) => setTimeout(r, delayMs));
      try {
        return await post();
      } catch (e2) {
        if (e2?.response?.status !== 409) throw e2;
      }
    }
    throw e;
  }
}
